/**
 * Unit price precision (2dp default, 3dp for fuel / ring-by-amount).
 * Sale totals and ring-by-amount extended prices remain 2dp (cents).
 */

export const MONEY_TOTAL_DECIMALS = 2
export const UNIT_DECIMALS_DEFAULT = 2
export const UNIT_DECIMALS_EXTENDED = 3

export function unitPriceDecimals (product) {
  if (!product) return UNIT_DECIMALS_DEFAULT
  if (product.ring_by_amount) return UNIT_DECIMALS_EXTENDED
  const d = Number(product.price_decimals)
  return d === UNIT_DECIMALS_EXTENDED ? UNIT_DECIMALS_EXTENDED : UNIT_DECIMALS_DEFAULT
}

export function roundUnitPrice (value, decimals = UNIT_DECIMALS_DEFAULT) {
  const n = Number(value)
  if (!Number.isFinite(n)) return 0
  const scale = decimals === UNIT_DECIMALS_EXTENDED ? UNIT_DECIMALS_EXTENDED : UNIT_DECIMALS_DEFAULT
  const factor = 10 ** scale
  return Math.round(n * factor) / factor
}

export function roundUnitPriceForProduct (value, product) {
  return roundUnitPrice(value, unitPriceDecimals(product))
}

export function formatUnitPrice (value, decimals = UNIT_DECIMALS_DEFAULT) {
  return roundUnitPrice(value, decimals).toFixed(decimals === UNIT_DECIMALS_EXTENDED ? 3 : 2)
}

export function formatUnitPriceCurrency (value, decimals = UNIT_DECIMALS_DEFAULT) {
  return `$${formatUnitPrice(value, decimals)}`
}

export function unitPriceInputStep (decimals = UNIT_DECIMALS_DEFAULT) {
  return decimals === UNIT_DECIMALS_EXTENDED ? '0.001' : '0.01'
}

/**
 * Resolve unit-price display decimals for invoice / document lines.
 *
 * @param {object|null|undefined} line
 * @param {object|null|undefined} [product]
 */
export function resolveLineUnitDecimals (line, product = null) {
  const meta = line?.metadata && typeof line.metadata === 'object' ? line.metadata : {}
  if (meta.ring_by_amount) return UNIT_DECIMALS_EXTENDED
  const fromMeta = Number(meta.price_decimals)
  if (fromMeta === UNIT_DECIMALS_EXTENDED) return UNIT_DECIMALS_EXTENDED
  const fromProduct = Number(product?.price_decimals)
  if (fromProduct === UNIT_DECIMALS_EXTENDED) return UNIT_DECIMALS_EXTENDED
  if (product?.ring_by_amount) return UNIT_DECIMALS_EXTENDED
  return UNIT_DECIMALS_DEFAULT
}
